import React, { useState, useEffect, useCallback } from 'react';
import './Carousel.css';
import banner11 from '../images/banner11.jpg';
import banner22 from '../images/banner22.jpg';
import banner33 from '../images/banner33.jpg';
import banner44 from '../images/banner44.jpg';
import banner55 from '../images/banner55.jpeg';
import banner66 from '../images/banner66.jpg';

const CarouselBlog = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const slides = [
    {
      image: banner33,
      cta: 'Learn More'
    },
    {
      image: banner22,
      cta: 'Donate Now'
    },
    {
      image: banner11,
      cta: 'View Publications'
    },
    {
      image: banner44,
      cta: 'View'
    },
    {
      image: banner55,
      cta: 'View'
    },
    {
      image: banner66,
      cta: 'View'
    }
  ];

  // Smooth transition to next slide
  const goToNext = useCallback(() => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
  }, [isTransitioning, slides.length]);

  // Smooth transition to previous slide
  const goToPrev = useCallback(() => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrentSlide((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
  }, [isTransitioning, slides.length]);

  // Direct slide navigation
  const goToSlide = useCallback((index) => {
    if (isTransitioning || index === currentSlide) return;
    setIsTransitioning(true);
    setCurrentSlide(index);
  }, [isTransitioning, currentSlide]);

  // Auto-advance with transition completion handling
  useEffect(() => {
    const interval = setInterval(goToNext, 5000);
    return () => clearInterval(interval);
  }, [goToNext]);

  // Reset transitioning state after animation completes
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsTransitioning(false);
    }, 600); // Match this with CSS transition duration

    return () => clearTimeout(timer);
  }, [currentSlide]);

  return (
    <div className="carousel-container">
      <div 
        className={`carousel-slides ${isTransitioning ? 'transitioning' : ''}`}
        style={{ transform: `translateX(-${currentSlide * 100}%)` }}
      >
        {slides.map((slide, index) => (
          <div key={index} className="slide">
            <div className="image-container">
              <div className="image-overlay"></div>
              <img 
                src={slide.image} 
                alt={`Banner ${index + 1}`} 
                className="slide-image"
                loading="lazy"
                onError={(e) => {
                  e.target.src = '/placeholder-banner.jpg';
                }}
              />
            </div>
            <div className="slide-content">
              <button className="slide-cta">{slide.cta}</button>
            </div>
          </div>
        ))}
      </div>

      <button 
        className="carousel-control prev" 
        onClick={goToPrev} 
        aria-label="Previous slide"
        disabled={isTransitioning}
      >
        &#10094;
      </button>
      <button 
        className="carousel-control next" 
        onClick={goToNext} 
        aria-label="Next slide"
        disabled={isTransitioning}
      >
        &#10095;
      </button>

      <div className="carousel-indicators">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`indicator ${index === currentSlide ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
            aria-label={`Go to slide ${index + 1}`}
            disabled={isTransitioning}
          />
        ))}
      </div>
    </div>
  );
};

export default CarouselBlog;